// extracted by mini-css-extract-plugin
export default {"rating":"uR-z","numberOfStars":"vR-z","count":"wR-z","barGraphSpacing":"xR-z","barGraph":"yR-z"};